import { useAppStore } from '../store/appStore'

export function SkipButton() {
  const skip = useAppStore((s) => s.skipToLab)
  return (
    <button className="skip-button" onClick={skip} title="跳过引导页，直接进入主站（Esc）">
      跳过 <span aria-hidden>→</span>
    </button>
  )
}
